import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import VueSVGIcon from 'vue-svgicon'

import Layout from '@/components/Layout'
import Details from '@/components/Details'
import LoadingScreen from '@/components/LoadingScreen'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(VueSVGIcon)
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/locationList',
      name: 'Layout',
      component: Layout,
      children: [{
        path: 'details/:locationId',
        name: 'Details',
        component: Details,
        props: true
      }],
      props: true
    },
    {
      path: '/loading',
      name: 'LoadingScreen',
      component: LoadingScreen
    },
    {
      path: '*',
      redirect: '/loading'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.afterEach(() => {
  console.log('here!' + window.scrollY)
  let cosParameter = window.scrollY / 2
  let scrollCount = 0
  let scrollDuration = 0.005
  let oldTimestamp = performance.now()

  function step (newTimestamp) {
    scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp))
    if (scrollCount >= Math.PI) window.scrollTo(0, 0)
    if (window.scrollY === 0) return
    window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)))
    oldTimestamp = newTimestamp
    console.log('here3!')
    window.requestAnimationFrame(step)
  }

  window.requestAnimationFrame(step)
  console.log('here 2!')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js